import React, { useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import ProductInfo from '../components/ProductInfo';
const ModularProductCards = ({ data }) => {
  const [selectedPlan, setSelectedPlan] = useState();
  const [selectedBundle, setSelectedBundle] = useState();
  const {
    heading,
    floatingImage,
    subheading,
    forcePromotion,
    forceContract,
    bottomText,
    defaultChosenProduct,
    isProductPagePath,
    isMainPage,
  } = data;

  let overrideCardContracts = undefined;
  let forceCardContract = undefined;
  switch (forceContract) {
    case '12':
      overrideCardContracts = { '12Months': '12 months' };
      forceCardContract = '12Months';
      break;
    case '18':
      overrideCardContracts = { '18Months': '18 months' };
      forceCardContract = '18Months';
      break;
    case '24':
      overrideCardContracts = { '24Months': '24 months' };
      forceCardContract = '24Months';
      break;
  }

  let forceParamsContract;
  useEffect(() => {
    if (typeof window !== undefined) {
      const urlParams = new URLSearchParams(window.location.search);
      forceParamsContract = urlParams.get('contract');
    }
  }, []);
  return (
    <div className="modular-product-cards-container">
      <ProductInfo
        header={heading ?? 'Find the perfect speed for your home'}
        subheader={
          subheading ??
          `Whether you're an occasional browser, boxset binger or hardcore gamer, we have the speed you need`
        }
        floatingImage={floatingImage}
        forceRegionalPromo={forcePromotion}
        overrideContracts={overrideCardContracts}
        forceContract={forceCardContract ?? forceParamsContract}
        defaultChosenProduct={defaultChosenProduct}
        bottomText={bottomText}
        isProductPagePath={isProductPagePath}
        isMainPage={isMainPage}
        setSelectedPlan={setSelectedPlan}
        selectedPlan={selectedPlan}
        setSelectedBundle={setSelectedBundle}
        selectedBundle={selectedBundle}
      />
    </div>
  );
};

export default ModularProductCards;
export const fragment = graphql`
  fragment ModularProductCards on DatoCmsProductCardsBlock {
    internal {
      type
    }
    forcePromotion
    forceContract
    defaultChosenProduct
    isProductPagePath
    isMainPage
    id
    heading {
      value
    }
    bottomText {
      value
    }
    floatingImage {
      gatsbyImageData
    }
    subheading {
      value
    }
  }
`;
